<template>
  <div class="login-box">
    <img class="login-box-img" :src="background_img" alt="" v-if="background_img !== ''">
    <img  v-if="background_img == ''" alt="" class="login-box-img" src="../../static/image/logo.png">
    <div class="login-content">
      <img :src="logoimgsrc" alt="" v-if="logoimgsrc !== ''" class="login-img">
      <img  v-if="logoimgsrc == ''" alt=""  src="../../static/image/logo.png"  class="login-img">
      <div class="login-input-box" v-if="!method">
        <div class="login-input">
          <span class="login-input-label">账号</span>
          <el-input v-model="login.mobile" placeholder="请输入手机号"></el-input>
        </div>
        <div class="login-input">
          <span class="login-input-label">密码</span>
          <el-input v-model="login.user_pass" placeholder="请输入密码" show-password @keyup.enter.native="loginFun"></el-input>
        </div>
        <div class="password-forget" >
          <el-checkbox v-model="passwordFlag">记住密码</el-checkbox>
          <span @click="forgetFun()">忘记密码</span>
        </div>
        <div class="login-button" @click="loginFun()">登录</div>
      </div>


      <div class="login-input-box" v-if="method">
        <div class="login-input">
          <span class="login-input-label">手机号</span>
          <el-input v-model="password.mobile" placeholder="请输入手机号"></el-input>
        </div>
        <div class="login-input-verify login-input">
          <span class="login-input-label">验证码</span>
          <el-input v-model="password.code" placeholder="请输入验证码"></el-input>
          <div class="verift-tips" v-if="time != 60">{{time}}秒后重发</div>
          <div class="verift-tips" v-if="time === 60" @click="codeFun()">发送验证码</div>
        </div>
        <div class="login-input">
          <span class="login-input-label">新密码</span>
          <el-input v-model="password.user_pass" placeholder="请输入新密码" show-password @keyup.enter.native="passwordFun"></el-input>
        </div>
        <div class="login-button" @click="passwordFun()">登录</div>
      </div>

      <div class="login-tips">西安点点欢乐提供技术支持</div>
    </div>

  </div>
</template>

<script>
export default {
  name: "login",
  data(){
   return {
     login: {
       mobile: '',
       user_pass: ''
     },
     password: {
       mobile: '',
       code: '',
       user_pass: '',
     },
     time: 60,
     method: false,
     background_img: '',
     logoimgsrc:'',
     passwordFlag:false
   }
  },
  mounted() {
    window.localStorage.removeItem('userInfo')
    window.localStorage.removeItem('openid')
    window.localStorage.removeItem('navList')
    window.localStorage.removeItem('token')
    if(JSON.parse(window.localStorage.getItem('shopInfo')) && JSON.parse(window.localStorage.getItem('shopInfo')).hasOwnProperty('background_img')){
      this.background_img = JSON.parse(window.localStorage.getItem('shopInfo')).background_img
      this.logoimgsrc = JSON.parse(window.localStorage.getItem('shopInfo')).logoimgsrc
    }
    this.login.mobile = window.localStorage.getItem('mobile')
    if(JSON.parse((window.localStorage.getItem('account')))){
      const accountData = JSON.parse((window.localStorage.getItem('account')))
      this.password = {
        mobile: accountData.mobile,
          code: '',
          user_pass: accountData.user_pass,
      }
      this.passwordFlag = true
    }
  },
  methods: {
    forgetFun() {
      this.method = true
    },
    async codeFun() {
      if (this.password.mobile !== '' && this.password.mobile.trim().length === 11) {
        this.$post(`/pc/sendSms`, {mobile: this.password.mobile.trim()})
          .then((response) => {
            if (response.code === 0) {
              let timeClock = setInterval(() => {
                this.time--
                if (this.time === 0) {
                  clearInterval(timeClock)
                  this.time = 60
                }
              }, 1000)
            }else {
              this.$message.error(response.data.Message);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.$message.error('请输入11位手机号');
      }

    },
    async passwordFun() {
      if (this.password.mobile === '' || this.password.mobile.trim().length !== 11) {
        this.$message.error('请输入11位手机号');
        return
      }
      if (this.password.code === '') {
        this.$message.error('请输入验证码');
        return
      }
      if (this.password.user_pass === '') {
        this.$message.error('请输入新密码');
        return
      }
      if(this.passwordFlag){
        window.localStorage.setItem("account",JSON.stringify({mobile: this.login.mobile.trim(),user_pass:this.login.user_pass.trim()}))
      }else{
        window.localStorage.removeItem("account")
      }
      this.$post(`pc/forgetThePassword`, { mobile:this.password.mobile.trim(),code: this.password.code.trim(),user_pass:this.password.user_pass.trim()})
        .then((response) => {
          if (response.data.code === 0) {
            window.localStorage.setItem("mobile", this.password.mobile.trim());
            window.localStorage.setItem("token", response.data.data.token);
            window.localStorage.setItem("userInfo", response.data.data.user);
            this.getShopImg()
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    async loginFun() {
      if (this.login.mobile === '' || this.login.mobile.trim().length !== 11) {
        this.$message.error('请输入11位手机号');
        return
      }
      if (this.login.user_pass === '') {
        this.$message.error('请输入密码');
        return
      }
      if(this.passwordFlag){
        window.localStorage.setItem("account",JSON.stringify({mobile: this.login.mobile.trim(),user_pass:this.login.user_pass.trim()}))
      }else{
        window.localStorage.removeItem("account")
      }
      this.$post(`/pc/login`,{mobile: this.login.mobile.trim(),user_pass:this.login.user_pass.trim()})
        .then((response) => {
          if (response.code === 0) {
            window.localStorage.setItem("mobile", this.login.mobile.trim());
            window.localStorage.setItem("token", response.data.token);
            window.localStorage.setItem("userInfo", JSON.stringify(response.data.user));
            this.getShopImg()
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getShopImg(){
      this.$get('/pc/shop/info', {}).then((res) => {
        window.localStorage.setItem("shopInfo",  JSON.stringify(res.data));
        this.$router.push({name:'home'})
      }).catch((error) => {
        this.$message.error(error.message);
      })
    }
  }
}
</script>

<style scoped lang="less" >
.login-box{
  position:relative;
  width: 100vw;
  height: 100vh;
  background: #000;
  overflow: hidden;
}
.login-content{
  position:absolute;
  top:50%;
  left:50%;
  box-sizing: border-box;
  width: 32.8vw;
  height: 43.75vw;
  padding:5.72vw 4.68vw 40px 4.68vw;
  display: flex;
  flex-direction: column;
  align-items: center;

  margin-top: -21.87vw;
  margin-left: -17.39vw;
  background: #FFFFFF;
  border-radius: 4px;
}

.login-box-img{
  width: 100%;
  height: 100%;
  overflow: hidden;
}
.login-input-box{
  height: 300px;
}

//.login-content img{
//  width: 8.75vw;
//  height: 8.75vw;
//  margin-bottom: 3.1vw;
//  border-radius: 10px;
//}
.login-img {
  width: 8.75vw;
  height: 8.75vw;
  border-radius: 10px;
}

.login-input{
  display: flex;
  align-items: center;
  height: 5.1vw;
  border-bottom: 1px solid #eeeeee;
  .el-input__inner{
    border:none;
    font-size: 24px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #353535;
  }
}
.login-input .login-input-label{
  display: block;
  width: 80px;
  font-size: 24px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #353535;
}
.login-input .el-input{
  width: 80%;
}

.login-input-verify .el-input{
  width: 60%;
}
.verift-tips{
  width: 103px;
  height: 40px;
  line-height: 40px;
  border: 2px solid #333333;
  opacity: 0.5;
  border-radius: 4px;
  font-size: 18px;
  text-align:center;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #333333;
  opacity: 0.5;
}

.el-input .el-input__clear{
  font-size:30px!important;
}


.login-button{
  width: 26vw;
  height: 3.48vw;
  line-height:2.96vw;
  background: #333333!important;
  border-radius: 4px;
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
  text-align:center;
}
.login-button span{
  font-size: 22px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #FFFFFF;
}
.password-forget{
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
  height: 22px;

  margin: 20px 0;

  span{
    font-size: 22px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    color: #676767;
    text-align:right;
  }
}
.login-tips{
  width: 100%;
  height: 17px;
  margin-top: 7.18vw;
  font-size: 18px;
  font-family: Microsoft YaHei;
  font-weight: 300;
  color: #222222;
  text-align:center;
}

</style>



// WEBPACK FOOTER //
// src/views/login.vue